'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosNutrition = function IoIosNutrition(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28 18.3c0.5 0.5 0.8 1 0.8 1.7 0 0.9-0.4 1.6-1.1 2s-3.9 3-8.2 6.1l-3-2.5c-0.3-0.2-0.6-0.2-0.8-0.1-0.2 0.2-0.2 0.5 0.1 0.8l2.2 2.8-8.9 6.5c-0.4 0.3-1 0.7-1.6 0.7-1.4 0-2.5-1.1-2.5-2.5 0-0.6 0.2-1.1 0.4-1.5 0.1-0.1 1.2-1.9 2.8-4.4l1.6 1.3c0.3 0.3 0.6 0.3 0.7 0.1 0.2-0.2 0.2-0.5 0-0.8l-1.6-1.8c2.1-3.3 4.7-7.5 6.6-10.4l2.8 2.3c0.3 0.2 0.6 0.2 0.8 0.1 0.1-0.2 0.1-0.5-0.1-0.8l-2.6-3.1c0.9-1.4 1.4-2.3 1.4-2.3 0.5-0.8 1.3-1.2 2.2-1.2 0.7 0 1.4 0.3 1.9 0.7l6.2 6.3z m7-7.4l-8 4.6-2.2-2.3 5.4-9.5 2.2 1.3-3.9 6.6 5.2-2.9z' })
        )
    );
};

exports.default = IoIosNutrition;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-nutrition.js
// module id = 2223
// module chunks = 0